<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns">
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <div @click="toggleDialog" style="cursor:pointer">
          <v-img
            src="https://streetcar-east.s3.us-east-2.amazonaws.com/prop+align+stop_07.png"
            style="max-width: 90%;"
          />
        </div>
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
        />
      </v-col>
      <v-col :cols="columns" style="max-height: 85vh; overflow-y: auto;">
        <v-card class="slide-card" style="max-width: 95%;">
          <div class="slide-content">
            <h1 id="header">
              Check Out the Proposed Alignment and Stop Locations
            </h1>
            <p>
              Heading east from Jackson Street, the alignment provides streetcar
              service in both directions along Edgewood Avenue, then north on
              Randolph Street and Auburn Avenue, making a connection to the
              Atlanta BeltLine Eastside corridor at Irwin Street, continuing
              north to Ponce de Leon Avenue. The current alignment proposes five
              stop locations.
            </p>
            <p><strong>Benefits of the current alignment include:</strong></p>
            <p style="padding-left: 5%;">
            <ul>
              <li>Increases last-mile connectivity</li>
              <li>Provides convenient and comfortable service</li>
              <li>
                One-seat transit rides between Eastside BeltLine corridor and
                downtown
              </li>
              <li>Connects to existing MARTA service</li>
              <li>Supports a five-minute walk from key destinations</li>
            </ul>
            </p>
            <br />
            <p>
              <strong>
                Click the alignment and stop locations display to view the map
                in greater detail.
              </strong>
            </p>
            <p>
              Click the display to view the current alignment route with
              potential Streetcar stop locations and cross sections.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <ImagePopup v-if="toggled" :close-modal="toggleDialog" :image="image" />
  </v-sheet>
</template>

<script>
import ImagePopup from "@/components/ImagePopup.vue";

export default {
  name: "ProposedAlignment",
  components: {
    ImagePopup
  },
  data() {
    return {
      toggled: false,
      image:
        "https://streetcar-east.s3.us-east-2.amazonaws.com/prop+align+stop_07.png"
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleDialog() {
      this.toggled = !this.toggled;
    }
  }
};
</script>
